import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Footer } from "@/components/layout/Footer";
import { Card } from "@/components/ui/Card";
import { Logo } from "@/components/ui/Logo";
import { hasUserCookie } from "@/lib/auth-cookie";
import { ensureSessionMarker } from "@/lib/session-probe";
import { brand } from "@/theme/themes";

export const Route = createFileRoute("/_setup")({
	beforeLoad: async ({ context }) => {
		// Auth-Guard: muss eingeloggt sein. Wie in _app erst den Marker klären,
		// falls er fehlt — sonst schickt ein verlorener Marker den Kunden mitten
		// aus den Register-Steps heraus auf /login.
		await ensureSessionMarker(context.queryClient);

		if (!hasUserCookie()) {
			throw redirect({ to: "/login" });
		}
	},
	component: SetupLayout,
});

function SetupLayout() {
	// Gleiche zentrierte Card wie _auth, kein Header/MobileNav
	return (
		<div className="min-h-screen bg-background flex flex-col">
			<div className="flex-1 flex flex-col items-center justify-center p-4">
				<div className="w-full max-w-md">
					<div className="flex flex-col items-center gap-3 mb-8">
						<a href="/" className="no-underline">
							<Logo size={48} />
						</a>
						<span className="text-2xl font-bold bg-gradient-to-r from-primary to-primary-gradient-end bg-clip-text text-transparent">
							{brand.siteName}
						</span>
					</div>
					<Card glass padding="lg" className="!overflow-visible">
						<Outlet />
					</Card>
				</div>
			</div>
			<Footer minimal />
		</div>
	);
}
